export const columnsDataPurchaseHistory = [
  {
    Header: "NAME",
    accessor: "user.name",
  },
  {
    Header: "SERVICE",
    accessor: "product.name",
  },
  {
    Header: "ACTION",
    accessor: "product",
  },
  {
    Header: "TGL BELI",
    accessor: "created_at",
  },
];